
(function($){

    $.fn.shuffle = function() {

        var allElems = this.get(),
            getRandom = function(max) {
                return Math.floor(Math.random() * max);
            },
            shuffled = $.map(allElems, function(){
                var random = getRandom(allElems.length),
                    randEl = $(allElems[random]).clone(true)[0];
                allElems.splice(random, 1);
                return randEl;
           });

        this.each(function(i){
            $(this).replaceWith($(shuffled[i]));
        });

        return $(shuffled);

    };

})(jQuery);

$('.random-team__slide').shuffle();
$('.random-team').each(function() {
  var $slideshow = $(this);
  var $slides = $(".random-team__slide",$slideshow);
  var index = $slides.length - 1;
  var count = $slides.length;
  $slides.first().addClass('random-team__slide--active');
  setInterval(function() {
    $slides.eq(index).removeClass('random-team__slide--active');
    index = (index + 1 ) % (count - 1);
    $slides.eq(index).addClass('random-team__slide--active');
  }, $slideshow.data('speed'));
});
